module.exports = __webpack_public_path__ + "img/se.92c66d83.svg";